import React from 'react';
import { observable, toJS } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import format from 'date-fns/format';

import { Row, Button, Popconfirm, RecordSelect } from '@smartplatform/ui';
import QuestionCard from './question-card/QuestionCard';
import voting from './store-admin';
import store from '../../store';
import { getEpzFileUrl } from 'root/tools/constants/epz';

@withRouter
@observer
export default class Session extends React.Component {
	constructor(props) {
		super(props);
		if (props.match.params.id) {
			voting.init(props.match.params.id);
		} else {
			voting.error = 'Не указан ID.';
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.match.params.id && parseInt(this.props.match.params.id) !== voting.id) {
			voting.init(this.props.match.params.id);
		}
	}

	componentWillUnmount() {
		voting.stopUpdates();
	}

	onChairmanChange = async deputy => {
		voting.session.chairman = deputy;
		await voting.session.save();
	};

	startRegistration = async () => {
		voting.session.registrationStart = new Date();
		await voting.session.save();
	};

	render() {
		if (voting.error) return <div className="error">{voting.error}</div>;
		if (voting.isLoading || !voting.session) return 'Загрузка...';

		return (
			<div className="session-admin">
				<div className="form-field">
					<label>Наименование</label>
					<div>{voting.session.name}</div>
				</div>

				<Row>
					<div className="form-field">
						<label>Председатель заседания</label>
						<RecordSelect
							model={store.model.Deputy}
							computed={voting.fio}
							value={voting.session.chairman}
							onChange={this.onChairmanChange}
							className="drop-down-md"
						/>
					</div>
					<div />
					<div />
				</Row>

				<div className="row">
					<div className="form-field col-lg-2">
						<label>Начало регистрации</label>
						{voting.session.registrationStart ? (
							<input type="text" value={format(new Date(voting.session.registrationStart), 'dd.MM.yyyy HH:mm')} disabled={true} />
						) : (
							<Button onClick={this.startRegistration} className="btn-primary">
								Начать регистрацию
							</Button>
						)}
					</div>
					{voting.session.registrationStart ? (
						<div className="form-field col-lg-4">
							<label>Количество зарегистрированных</label>
							<div className="with-text">
								<input type="text" value={voting.members.length + 35} style={{ width: '50%' }} disabled={true} />
								{voting.members.length + 35 >= 36 ? (
									<span>
										<span className="disc green" />
										Кворум достигнут
									</span>
								) : (
									<span>
										<span className="disc red" />
										Кворума нет
									</span>
								)}
							</div>
							<div className="hint">+35 в целях тестирования</div>
						</div>
					) : (
						<div className="col-lg-4" />
					)}
					<div className="col-lg-6" />
				</div>

				{/*
			<hr />
			<div className="questions">
				{voting.questions.map(question => <QuestionCard key={question.id} question={question} />)}
			</div>
*/}

				{/*
			<ol className="questions">
				{this.questions.map(question => <li key={question.id} className="question">
					<strong>{question.name}</strong> ({question.order})
					<ul className="files">
						{question.files.map(file => {
							if (!file.url && !file.pages) return null;
							let link = file.url ?
								<a target="_blank" href={file.url}>{file.name}</a>
								:
								<>
									{file.name}:&nbsp;
									{file.pages.map((page, i) => <span key={'page' + i}>
										<a target="_blank" href={getEpzFileUrl(page, store.recentPlenarySessions)}>стр. {i + 1}</a>&nbsp;
									</span>)}
								</>
							return <li key={file.id}>{link}</li>;
						})}
					</ul>
				</li>)}
			</ol>
*/}

				<hr />

				<Popconfirm onConfirm={voting.resetSession} content="Сбросить?">
					<Button className="btn-danger">Сбросить данные голосования</Button>
				</Popconfirm>
			</div>
		);
	}
}
